import React, { useState, useRef, useEffect } from 'react';

const stations = [
  { name: 'Antyradio', url: 'http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx' },
  { name: 'RMF FM', url: 'http://195.150.20.9:8000/rmf_fm' },
  { name: 'Radio Zet', url: 'http://n-4-2.dcs.redcdn.pl/sc/o2/Eurozet/live/audio.livx' }
];

const RadioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentStation, setCurrentStation] = useState(stations[0].url);
  const [volume, setVolume] = useState(0.5);
  const [location, setLocation] = useState(null);
  const [browserInfo, setBrowserInfo] = useState(null);
  const [showCookiesPopup, setShowCookiesPopup] = useState(true);
  const audioRef = useRef(new Audio(currentStation));

  useEffect(() => {
    audioRef.current.src = currentStation;
    audioRef.current.volume = volume;
  }, [currentStation, volume]);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleStationChange = (event) => {
    setCurrentStation(event.target.value);
    setIsPlaying(false);
  };

  const handleVolumeChange = (event) => {
    setVolume(event.target.value);
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation(`Lat: ${position.coords.latitude}, Lng: ${position.coords.longitude}`);
        },
        () => {
          setLocation('Nie udało się uzyskać lokalizacji.');
        }
      );
    }
    setBrowserInfo(`${navigator.userAgent}`);
  }, []);

  return (
    <div className="radio-player">
      <h2>Odtwarzacz Radiowy</h2>
      <select onChange={handleStationChange} value={currentStation}>
        {stations.map((station, index) => (
          <option key={index} value={station.url}>{station.name}</option>
        ))}
      </select>
      <button onClick={togglePlayPause}>{isPlaying ? 'Pauza' : 'Odtwórz'}</button>
      <input type="range" min="0" max="1" step="0.1" value={volume} onChange={handleVolumeChange} />
      <p>Głośność: {Math.round(volume * 100)}%</p>
      <div className="info">
        <p><strong>Twoja lokalizacja:</strong> {location || 'Ładowanie...'}</p>
        <p><strong>Przeglądarka:</strong> {browserInfo}</p>
      </div>
      {showCookiesPopup && (
        <div className="cookies-popup">
          <p>Ta strona używa plików cookies. Kontynuując, zgadzasz się na ich użycie.</p>
          <button onClick={() => setShowCookiesPopup(false)}>OK</button>
        </div>
      )}
    </div>
  );
};

export default RadioPlayer;
